import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d46832ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_7 = { style: {"margin-top":"20px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "标签", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","margin-top":"20px"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "ID"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "sn"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "标签名")
], -1))
const _hoisted_10 = { class: "item" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, { title: "职位置顶日志" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          placeholder: "关键字",
          value: _ctx.searches.keywords,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.keywords) = $event)),
          style: {"width":"200px"}
        }, null, 8, ["value"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          type: "primary",
          onClick: _ctx.onSearch
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: _ctx.onReset
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: _ctx.columns,
          loading: _ctx.loading,
          bordered: "",
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'user_name')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(record.user.nickname), 1))
              : _createCommentVNode("", true),
            (column.key === 'post_name')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.log!== null )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(record.log.post.name), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'user_avatar')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 2,
                  src: record.user.avatar,
                  style: {"height":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'user_mobile')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(record.user.mobile), 1))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 4,
                  onClick: ($event: any) => (_ctx.getDetail(record))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      title: "岗位详情",
      footer: null,
      width: "50%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, { bordered: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "岗位名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "岗位人数" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.number), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "岗位需要" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.requirements), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "岗位职责" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.describe), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "工作经验" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.working_years), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "薪资范围" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.wages_start) + "——" + _toDisplayString(_ctx.detailData.wages_end), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "省份" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.province), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "城市" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.city), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "地区" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.area), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "地址" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.address), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.label, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              style: {"display":"flex"}
            }, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(item.id), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(item.sn), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}